import React from 'react'
import styles from './BarGroup.module.scss'

const AxisBottomText = ({maxBarSize, x, y, color, value, extraClassname}) => {
  const sizeWithPadding = maxBarSize-100

  return (
    <foreignObject x={x - sizeWithPadding / 2} y={y} width={sizeWithPadding} height="100px">
      <div className={styles['axiswrapper']}> 
        <p className={extraClassname} style={{color:color}}>{value}</p>
      </div>
    </foreignObject>
  )
}

export default AxisBottomText